import React, { useEffect, useState } from 'react'
import { apiCall } from '../../../Product/common/api'

export default function SiteMap(props) {
    const [sitemap, setSitemap] = useState('')

    async function generateSiteMap() {
        let sitemap = ''
        let xml = ''

        let formData = {
            url: `https://${window.location.hostname}`,
            productLink: 'product',
        }

        const [response] = await Promise.all([apiCall('post', 'sitemap', formData, '', '')])
        if (response.data.success === 'true') {
            sitemap = response.data.xmlData
        }
        console.log('sitemap return', sitemap)
        setSitemap(sitemap)
    }

    useEffect(async () => {
        generateSiteMap()
    }, [])

    return <>{sitemap}</>
}
